import { useLocation } from "react-router-dom";
import { AdminHeader } from "@/components/admin/AdminHeader";
import { getAdminPageScope, getAdminPageTitle } from "@/components/admin/adminNav";
import { MobileSidebarProvider } from "@/contexts/MobileSidebarContext";
import { AdminSidebar } from "../components/AdminSidebar";

interface AdminLayoutProps {
  children: React.ReactNode;
}

export function AdminLayout({ children }: AdminLayoutProps) {
  const location = useLocation();
  const title = getAdminPageTitle(location.pathname);
  const scope = getAdminPageScope(location.pathname);

  return (
    <MobileSidebarProvider>
      {/* admin-scope: denser, Manrope-only type scale (no display font) */}
      <div className="admin-scope flex h-screen overflow-hidden bg-gray-50 text-gray-900">
        <AdminSidebar />
        <div className="flex min-w-0 flex-1 flex-col">
          <AdminHeader title={title} scope={scope} />
          <main className="scrollbar-thin flex-1 overflow-auto p-4 md:p-6">{children}</main>
        </div>
      </div>
    </MobileSidebarProvider>
  );
}
